var React = require('react');

function IconUndo (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.2317 5.80136C17.0523 4.59977 15.5075 4 13.9618 4C12.4161 4 10.8713 4.60079 9.69188 5.80136L6.01269 9.55069V5.87415H4V13.0509H11.0444V11.0004H7.43566L11.1159 7.25106C11.4887 6.86908 11.9322 6.56621 12.4207 6.35996C12.9092 6.15371 13.433 6.04818 13.9618 6.04947C15.0366 6.04947 16.048 6.47597 16.8077 7.25106C17.5617 8.02068 17.9852 9.06361 17.9852 10.151C17.9852 11.2383 17.5617 12.2813 16.8077 13.0509L11.4097 18.5503L12.8327 20L18.2307 14.5006C18.7915 13.9295 19.2365 13.2515 19.54 12.5052C19.8436 11.7589 19.9999 10.959 20 10.1512C20.0001 9.34335 19.844 8.54342 19.5406 7.79707C19.2372 7.05072 18.7924 6.37257 18.2317 5.80136V5.80136Z","fill":"white"}));
}

IconUndo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconUndo;

IconUndo.default = IconUndo;
